var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcast1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8443 12.7467C13.5665 12.7477 14.2596 12.4435 14.7711 11.9009C15.2826 11.3584 15.5707 10.6219 15.5719 9.85348C15.5705 9.08514 15.2824 8.34884 14.7709 7.80644C14.2594 7.26404 13.5664 6.95992 12.8443 6.96094C12.1223 6.96009 11.4296 7.2642 10.9182 7.80644C10.4069 8.34869 10.1188 9.08472 10.1172 9.85284C10.1183 10.6213 10.4062 11.3578 10.9176 11.9005C11.429 12.4431 12.122 12.7475 12.8443 12.7467Z",
    stroke: "#4A81E6",
    strokeWidth: 1.70237,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05144 4.0435C4.85156 7.2163 4.85156 12.3617 8.05144 15.5345M17.6517 15.5345C20.8516 12.3617 20.8516 7.2163 17.6517 4.0435M4.36615 0.851562C-0.319967 5.82205 -0.319967 13.8811 4.36615 18.8516M21.337 18.8516C26.0231 13.8811 26.0231 5.82205 21.337 0.851562",
    stroke: "#4A81E6",
    strokeWidth: 1.70237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast1);
export default __webpack_public_path__ + "static/media/broadcast1.4efb68e819b4e68cd3c36607ced9342d.svg";
export { ForwardRef as ReactComponent };